// extracted by css-extract-rspack-plugin
export default {"container":"container-PVypMq","fieldsRow":"fieldsRow-zEaiKZ","quantityWrapper":"quantityWrapper-HbojqI","quantityLabel":"quantityLabel-PZKEcs"};